import React from "react";

// Crisp, brand-accurate payment logos rendered as SVG for HD sharpness.
const Visa = () => (
  <svg viewBox="0 0 48 32" className="h-6 w-auto" role="img" aria-label="Visa">
    <text x="24" y="23" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="18" fill="#1A1F71" letterSpacing="0.5">VISA</text>
  </svg>
);

const Mastercard = () => (
  <svg viewBox="0 0 48 32" className="h-7 w-auto" role="img" aria-label="Mastercard">
    <circle cx="19" cy="16" r="10" fill="#EB001B" />
    <circle cx="29" cy="16" r="10" fill="#F79E1B" />
    <path d="M24 8.5a10 10 0 0 1 0 15 10 10 0 0 1 0-15z" fill="#FF5F00" />
  </svg>
);

const Amex = () => (
  <svg viewBox="0 0 48 32" className="h-7 w-auto" role="img" aria-label="American Express">
    <rect width="48" height="32" rx="4" fill="#2E77BB" />
    <text x="24" y="14" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="7" fill="#fff">AMERICAN</text>
    <text x="24" y="23" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="800" fontSize="7" fill="#fff">EXPRESS</text>
  </svg>
);

const PayPal = () => (
  <svg viewBox="0 0 70 24" className="h-5 w-auto" role="img" aria-label="PayPal">
    <text x="0" y="19" fontFamily="Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="20" fill="#003087">Pay</text>
    <text x="35" y="19" fontFamily="Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="20" fill="#009CDE">Pal</text>
  </svg>
);

const ApplePay = () => (
  <svg viewBox="0 0 60 24" className="h-5 w-auto" role="img" aria-label="Apple Pay">
    <path d="M11.9 6.2c-.7.05-1.5.5-2 1.05-.4.5-.8 1.25-.65 1.95.75.05 1.5-.4 1.95-.95.45-.5.8-1.25.7-2.05zM12.6 9.3c-1.05-.05-1.95.6-2.45.6-.5 0-1.3-.55-2.15-.55-1.1.05-2.15.65-2.7 1.65-1.15 2-.3 4.95.85 6.55.55.8 1.2 1.7 2.05 1.65.8-.05 1.1-.55 2.1-.55s1.25.55 2.1.5c.85-.05 1.4-.8 1.95-1.6.6-.9.85-1.75.85-1.8-.05-.05-1.65-.65-1.65-2.55 0-1.6 1.3-2.35 1.35-2.4-.75-1.1-1.9-1.2-2.3-1.2z" fill="#000"/>
    <text x="19" y="18" fontFamily="-apple-system, Arial, sans-serif" fontWeight="600" fontSize="15" fill="#000">Pay</text>
  </svg>
);

const LOGOS = [
  { key: "visa", el: <Visa /> },
  { key: "mc", el: <Mastercard /> },
  { key: "amex", el: <Amex /> },
  { key: "paypal", el: <PayPal /> },
  { key: "applepay", el: <ApplePay /> },
];

export const PaymentLogos = ({ variant = "light", className = "" }) => {
  const cardCls =
    variant === "light"
      ? "bg-white border border-slate-200 shadow-sm"
      : "bg-white";
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="payment-logos">
      {LOGOS.map((l) => (
        <div
          key={l.key}
          data-testid={`payment-logo-${l.key}`}
          className={`h-11 min-w-[64px] px-3 rounded-xl flex items-center justify-center transition-transform hover:-translate-y-0.5 ${cardCls}`}
        >
          {l.el}
        </div>
      ))}
    </div>
  );
};
